/**
 * Custom Gym Banner — design request block (cgb_design_request) file guard.
 *
 * Shopify rejects a line-item property upload larger than its per-file limit,
 * and the add would fail after the customer has already filled the form. This
 * checks size client-side on the same capture-phase [data-to-cart] click the
 * other cgb scripts use, so an oversized file is reported inline instead.
 *
 * Registers before the V1/V2 addon interceptors because the block renders
 * earlier in block_order — see custom-gym-banner-text-color.js for the same
 * ordering contract.
 */
(() => {
  if (window.__cgbDesignRequestInstalled) return;
  window.__cgbDesignRequestInstalled = true;

  const SELECTOR_FILE = 'input[type="file"][data-cgb-max-mb]';
  const SELECTOR_BTN = '[data-to-cart]';
  const CLASS_ERROR = 'cgb-field--error';

  const fieldOf = (input) => input.closest('.cgb-field');

  const setError = (input, message) => {
    const field = fieldOf(input);
    if (!field) return;
    field.classList.add(CLASS_ERROR);
    const errorEl = field.querySelector('.cgb-field__error');
    if (errorEl) errorEl.textContent = message;
  };

  const clearError = (input) => {
    const field = fieldOf(input);
    if (!field) return;
    field.classList.remove(CLASS_ERROR);
    const errorEl = field.querySelector('.cgb-field__error');
    if (errorEl) errorEl.textContent = '';
  };

  const oversized = (input) => {
    const file = input.files && input.files[0];
    if (!file) return null;
    const maxMb = parseFloat(input.dataset.cgbMaxMb) || 20;
    if (file.size <= maxMb * 1024 * 1024) return null;
    return `"${file.name}" is ${(file.size / 1024 / 1024).toFixed(1)}MB — please attach a file under ${maxMb}MB.`;
  };

  document.addEventListener('click', (e) => {
    if (!e.target.closest(SELECTOR_BTN)) return;

    let firstInvalid = null;
    document.querySelectorAll(SELECTOR_FILE).forEach(input => {
      const message = oversized(input);
      if (message) {
        setError(input, message);
        if (!firstInvalid) firstInvalid = input;
      } else {
        clearError(input);
      }
    });

    if (!firstInvalid) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    try {
      firstInvalid.focus({ preventScroll: true });
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (_) { /* noop */ }
  }, true);

  document.addEventListener('change', (e) => {
    if (!e.target.matches || !e.target.matches(SELECTOR_FILE)) return;
    const message = oversized(e.target);
    if (message) setError(e.target, message); else clearError(e.target);
  });
})();
